var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('voice-select',{attrs:{"activatorClass":"tts-voice-selector","open":_vm.open,"voices":_vm.voices,"voice":_vm.voice},on:{"voice-changed":_vm.handleVoiceChanged,"menu-opened":_vm.handleMenuOpened}})
}
var staticRenderFns = []

export { render, staticRenderFns }